/**
 * Pure functions that produce a new workflow object with a mutation applied.
 * Used for post-success cache patching — only called after the API confirms
 * the mutation succeeded, so these are safe approximations that the background
 * refetch will reconcile.
 */

export function applyTaskToggle (workflow, stepId, taskId, wasComplete) {
  if (!workflow) return workflow

  const now = new Date().toISOString()

  return {
    ...workflow,
    workflow_steps: workflow.workflow_steps?.map(step => {
      if (step.id !== stepId) return step

      const updatedTasks = step.workflow_step_tasks?.map(task => {
        if (task.id !== taskId) return task
        return {
          ...task,
          completion_date: wasComplete ? null : now
        }
      })

      const openCount = updatedTasks?.filter(t => !t.completion_date).length ?? 0

      return {
        ...step,
        workflow_step_tasks: updatedTasks,
        tasks_remaining: openCount
      }
    })
  }
}

export function applyStepComplete (workflow, stepId, nextStepId) {
  if (!workflow) return workflow

  const now = new Date().toISOString()

  const updatedSteps = workflow.workflow_steps?.map(step => {
    if (step.id !== stepId) return step
    return {
      ...step,
      completion_date: now,
      tasks_remaining: 0,
      workflow_step_tasks: step.workflow_step_tasks?.map(task => ({
        ...task,
        completion_date: task.completion_date || now
      }))
    }
  })

  return {
    ...workflow,
    workflow_steps: updatedSteps,
    current_step_id: nextStepId ?? null,
    completion_date: nextStepId ? workflow.completion_date : now
  }
}
